import DeleteIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditIcon from "@mui/icons-material/EditOutlined";
import { useContext, useEffect, useState } from "react";
import SettingsSection from "../../../shared/components/SettingsSection";
import {
  ActionButton,
  TableActions,
  TableCell,
  TableRow,
} from "../../../shared/components/table/StyledTable";
import { isSure } from "../../../shared/helpers";
import ConfigDataProvider, {
  ConfigDataContext,
} from "../../../shared/providers/ConfigDataProvider";
import { GET_CONFIG_DATA, SET_CONFIG_DATA } from "../../../shared/reducer";
import { formatCurrency } from "../../../shared/utils";
import OCCategoriesDialog from "./OCCategoriesDialog";

const OCCategories = () => (
  <ConfigDataProvider>
    <OCCategoriesConsumer />
  </ConfigDataProvider>
);

const OCCategoriesConsumer = () => {
  const { state, dispatch } = useContext(ConfigDataContext);

  const categories = state?.data as any[];

  useEffect(() => {
    dispatch({
      type: GET_CONFIG_DATA,
      id: "OperatingCostCategories",
      private: true,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Dialog/current id being edited state and handlers
  const [dialogOpen, setDialogOpen] = useState(false);
  const [id, setId] = useState<string>("");
  const handleOpenDialog = (nextId: string) => {
    setId(nextId);
    setDialogOpen(true);
  };
  const handleCloseDialog = () => {
    setId("");
    setDialogOpen(false);
  };

  const handleDelete = async (categoryId: string) => {
    if (!(await isSure())) return;

    const payload = {
      ...state,
      data: categories?.filter((category) => category.id !== categoryId),
    };

    dispatch({ type: SET_CONFIG_DATA, payload });
  };

  return (
    <>
      <SettingsSection
        title="Nebenkosten-Kategorien"
        description="Kategorien und Richtpreise für die Nebenkostenprüfung"
        columns={["Kategorie", "Beschreibung", "Normaler Preis"]}
        onAdd={() => handleOpenDialog("")}
        addLabel="Kategorie"
        isEmpty={!categories?.length}
        emptyMessage="Noch keine Kategorien angelegt."
      >
        {categories?.map((category) => (
          <TableRow key={category.id}>
            <TableCell sx={{ fontWeight: 600 }}>{category.title}</TableCell>
            <TableCell sx={{ color: "text.secondary" }}>
              {category.description}
            </TableCell>
            <TableCell>{formatCurrency(category.usualPrice)}</TableCell>
            <TableCell align="right">
              <TableActions>
                <ActionButton
                  icon={<EditIcon />}
                  label="Kategorie bearbeiten"
                  onClick={() => handleOpenDialog(category.id)}
                />
                <ActionButton
                  icon={<DeleteIcon />}
                  label="Kategorie löschen"
                  onClick={() => handleDelete(category.id)}
                />
              </TableActions>
            </TableCell>
          </TableRow>
        ))}
      </SettingsSection>

      {dialogOpen && (
        <OCCategoriesDialog id={id} handleCloseDialog={handleCloseDialog} />
      )}
    </>
  );
};

export default OCCategories;
